import { lazy } from 'react';

import { getRoutesArray } from './manager';

const SignaturePage = lazy(() => import('~/domains/signature/SignaturePage'));

const HomePage = lazy(() => import('~/domains/home/HomePage'));
const CompaniesPage = lazy(() => import('~/domains/companies/CompaniesPage'));
const CompaniesCreateUpdatePage = lazy(() => import('~/domains/companies/CompaniesCreateUpdatePage'));
const UsersPage = lazy(() => import('~/domains/users/UsersPage'));
const UsersCreateUpdatePage = lazy(() => import('~/domains/users/UsersCreateUpdatePage'));
const BankPage = lazy(() => import('~/domains/bank/BankPage'));
const BankCreateUpdatePage = lazy(() => import('~/domains/bank/BankCreateUpdatePage'));
const GreetingsPage = lazy(() => import('~/domains/greetings/GreetingsPage'));
const GreetingsCreateUpdatePage = lazy(() => import('~/domains/greetings/GreetingsCreateUpdatePage'));
const UnitsPage = lazy(() => import('~/domains/units/UnitsPage'));
const UnitsCreateUpdatePage = lazy(() => import('~/domains/units/UnitsCreateUpdatePage'));
const AcademicDegreesPage = lazy(() => import('~/domains/academic-degrees/AcademicDegreesPage'));
const AcademicDegreesCreateUpdatePage = lazy(
    () => import('~/domains/academic-degrees/AcademicDegreesCreateUpdatePage'),
);
const BenefitsPage = lazy(() => import('~/domains/benefits/BenefitsPage'));
const BenefitsCreateUpdatePage = lazy(() => import('~/domains/benefits/BenefitsCreateUpdatePage'));
const CivilStatusPage = lazy(() => import('~/domains/civil-status/CivilStatusPage'));
const CivilStatusCreateupdatePage = lazy(() => import('~/domains/civil-status/CivilStatusCreateUpdatePage'));
const DepartmentPage = lazy(() => import('~/domains/department/departmentPage'));
const DepartmentCreateUpdatePage = lazy(() => import('~/domains/department/departmentCreateUpdatePage'));
const AccountTypePage = lazy(() => import('~/domains/account-types/AccountTypePage'));
const AccountTypeCreateUpdatePage = lazy(() => import('~/domains/account-types/AccountTypesCreateUpdatePage'));
const SchoolingCreateUpdatePage = lazy(() => import('~/domains/schooling/SchoolingCreateUpdatePage'));
const SchoolingPage = lazy(() => import('~/domains/schooling/SchoolingPage'));
const TypeContractPage = lazy(() => import('~/domains/type-contract/TypeContractPage'));
const TypeContractCreateUpdatePage = lazy(() => import('~/domains/type-contract/TypeContractCreateUpdatePage'));
const TypeAbsencesCreateUpdatePage = lazy(() => import(
    '~/domains/collaborators-types-absences/CollaboratorsTypesAbsencesCreateUpdatePage'
));
const TypeAbsences = lazy(() => import('~/domains/collaborators-types-absences/CollaboratorsTypesAbsencesPage'));
const UnionsPage = lazy(() => import('~/domains/unions/UnionsPage'));
const UnionsCreateUpdatePage = lazy(() => import('~/domains/unions/UnionsCreateUpdatePage'));
const LawyerPage = lazy(() => import('~/domains/lawyers/LawyerPage'));
const LawyerCreateUpdatePage = lazy(() => import('~/domains/lawyers/LawyerCreateUpdatePage'));
const PositionsPage = lazy(() => import('~/domains/positions/PositionsPage'));
const PositionsCreateUpdatePage = lazy(() => import('~/domains/positions/PositionsCreateUpdatePage'));
const DocumentsTypesPage = lazy(() => import('~/domains/documents-types/DocumentsTypesPage'));
const DocumentsTypesCreateUpdatePage = lazy(() => import('~/domains/documents-types/DocumentsTypesCreateUpdatePage'));
const EmployeesPage = lazy(() => import('~/domains/employees/EmployeesPage'));
const EmployeesCreateUpdatePage = lazy(() => import('~/domains/employees/EmployeesCreateUpdatePage'));
const EmployeeManagementPage = lazy(() => import('~/domains/employees/EmployeeManagementPage'));
const ClaimantsTypePage = lazy(() => import('~/domains/type-claimants/ClaimantsTypePage'));
const ClaimantsTypeCreateUpdatePage = lazy(() => import('~/domains/type-claimants/ClaimantsTypeCreateUpdatePage'));
const KinshipPage = lazy(() => import('~/domains/kinship/KinshipPage'));
const KinshipCreateUpdatePage = lazy(() => import('~/domains/kinship/KinshipCreateUpdatePage'));
const CriterionPage = lazy(() => import('~/domains/criterion/CriterionPage'));
const CriterionCreateUpdatePage = lazy(() => import('~/domains/criterion/CriterionCreateUpdatePage'));
const CoursesPage = lazy(() => import('~/domains/course/CoursesPage'));
const CoursesCreateUpdatePage = lazy(() => import('~/domains/course/CoursesCreateUpdatePage'));
const JusticeCreatePage = lazy(() => import('~/domains/justice-process/JusticeProcessCreatePage'));
const JusticeProcessManagementPage = lazy(() => import('~/domains/justice-process/JusticeProcessManagementPage'));
const JusticeProcessPage = lazy(() => import('~/domains/justice-process/JusticeProcessPage'));
const ProfilePage = lazy(() => import('~/domains/profile/ProfilePage'));
const ChangelogPage = lazy(() => import('~/domains/changelog/ChangelogPage'));
const DoctorsCreateUpdatePage = lazy(() => import('~/domains/doctors/DoctorsCreateUpdatePage'));
const DoctorsPage = lazy(() => import('~/domains/doctors/DoctorsPage'));

const COMPANIES = [
    {
        exact: true,
        path: '/empresas',
        menuKey: '/empresas',
        component: CompaniesPage,
        text: 'Empresas',
        icon: {
            family: 'MaterialIcons',
            name: 'Business',
        },
        permissions: [
            {
                can: 'find',
                an: 'Empresa',
            },
        ],
    },
    {
        path: '/empresas/novo',
        menuKey: '/empresas',
        component: CompaniesCreateUpdatePage,
        permissions: [
            {
                can: 'create',
                an: 'Empresa',
            },
        ],
    },
    {
        path: '/empresas/:companyId',
        menuKey: '/empresas',
        component: CompaniesCreateUpdatePage,
        permissions: [
            {
                can: 'update',
                an: 'Empresa',
            },
        ],
    },
];

const GREETINGS = [
    {
        exact: true,
        path: '/saudacoes',
        menuKey: '/saudacoes',
        component: GreetingsPage,
        text: 'Saudações',
        icon: {
            family: 'FontAwesome',
            name: 'Handshake',
        },
        permissions: [
            {
                can: 'find',
                an: 'Saudacao',
            },
        ],
    },
    {
        path: '/saudacoes/novo',
        menuKey: '/saudacoes',
        component: GreetingsCreateUpdatePage,
        permissions: [
            {
                can: 'create',
                an: 'Saudacao',
            },
        ],
    },
    {
        path: '/saudacoes/:id',
        menuKey: '/saudacoes',
        component: GreetingsCreateUpdatePage,
        permissions: [
            {
                can: 'update',
                an: 'Saudacao',
            },
        ],
    },
];

const ACADEMIC_DEGREES = [
    {
        exact: true,
        path: '/graduacoes-academicas',
        menuKey: '/graduacoes-academicas',
        component: AcademicDegreesPage,
        text: 'Graduações acadêmicas',
        icon: {
            family: 'FontAwesome',
            name: 'UserGraduate',
        },
        permissions: [
            {
                can: 'find',
                an: 'GraduacaoAcademica',
            },
        ],
    },
    {
        path: '/graduacoes-academicas/novo',
        menuKey: '/graduacoes-academicas',
        component: AcademicDegreesCreateUpdatePage,
        permissions: [
            {
                can: 'create',
                an: 'GraduacaoAcademica',
            },
        ],
    },
    {
        path: '/graduacoes-academicas/:id',
        menuKey: '/graduacoes-academicas',
        component: AcademicDegreesCreateUpdatePage,
        permissions: [
            {
                can: 'update',
                an: 'GraduacaoAcademica',
            },
        ],
    },
];

const BANKS = [
    {
        exact: true,
        path: '/bancos',
        menuKey: '/bancos',
        component: BankPage,
        text: 'Bancos',
        icon: {
            family: 'FontAwesome',
            name: 'Landmark',
        },
        permissions: [
            {
                can: 'find',
                an: 'Banco',
            },
        ],
    },
    {
        path: '/bancos/novo',
        menuKey: '/bancos',
        component: BankCreateUpdatePage,
        permissions: [
            {
                can: 'create',
                an: 'Banco',
            },
        ],
    },
    {
        path: '/bancos/:bankId',
        menuKey: '/bancos',
        component: BankCreateUpdatePage,
        permissions: [
            {
                can: 'update',
                an: 'Banco',
            },
        ],
    },
];

const UNIONS = [
    {
        exact: true,
        path: '/sindicatos',
        menuKey: '/sindicatos',
        component: UnionsPage,
        text: 'Sindicatos',
        icon: {
            family: 'FontAwesome',
            name: 'Users',
        },
        permissions: [
            {
                can: 'find',
                an: 'Sindicato',
            },
        ],
    },
    {
        path: '/sindicatos/novo',
        menuKey: '/sindicatos',
        component: UnionsCreateUpdatePage,
        permissions: [
            {
                can: 'create',
                an: 'Sindicato',
            },
        ],
    },
    {
        path: '/sindicatos/:id',
        menuKey: '/sindicatos',
        component: UnionsCreateUpdatePage,
        permissions: [
            {
                can: 'update',
                an: 'Sindicato',
            },
        ],
    },
];

const POSITIONS = [
    {
        exact: true,
        path: '/cargos',
        menuKey: '/cargos',
        component: PositionsPage,
        text: 'Cargos',
        icon: {
            family: 'FontAwesome',
            name: 'UserTie',
        },
        permissions: [
            {
                can: 'find',
                an: 'Cargo',
            },
        ],
    },
    {
        path: '/cargos/novo',
        menuKey: '/cargos',
        component: PositionsCreateUpdatePage,
        permissions: [
            {
                can: 'create',
                an: 'Cargo',
            },
        ],
    },
    {
        path: '/cargos/:id',
        menuKey: '/cargos',
        component: PositionsCreateUpdatePage,
        permissions: [
            {
                can: 'update',
                an: 'Cargo',
            },
        ],
    },
];

const UNITS = [
    {
        exact: true,
        path: '/unidades',
        menuKey: '/unidades',
        component: UnitsPage,
        text: 'Unidades',
        icon: {
            family: 'FontAwesome',
            name: 'MapMarkedAlt',
        },
        permissions: [
            {
                can: 'find',
                an: 'Unidade',
            },
        ],
    },
    {
        path: '/unidades/novo',
        menuKey: '/unidades',
        component: UnitsCreateUpdatePage,
        permissions: [
            {
                can: 'create',
                an: 'Unidade',
            },
        ],
    },
    {
        path: '/unidades/:id',
        menuKey: '/unidades',
        component: UnitsCreateUpdatePage,
        permissions: [
            {
                can: 'update',
                an: 'Unidade',
            },
        ],
    },
];

const BENEFITS = [
    {
        exact: true,
        path: '/beneficios',
        menuKey: '/beneficios',
        component: BenefitsPage,
        text: 'Benefícios',
        icon: {
            family: 'FontAwesome',
            name: 'MoneyCheckAlt',
        },
        permissions: [
            {
                can: 'find',
                an: 'Beneficio',
            },
        ],
    },
    {
        path: '/beneficios/novo',
        menuKey: '/beneficios',
        component: BenefitsCreateUpdatePage,
        permissions: [
            {
                can: 'create',
                an: 'Beneficio',
            },
        ],
    },
    {
        path: '/beneficios/:benefitId',
        menuKey: '/beneficios',
        component: BenefitsCreateUpdatePage,
        permissions: [
            {
                can: 'update',
                an: 'Beneficio',
            },
        ],
    },
];

const TYPE_CONTRACT = [
    {
        exact: true,
        path: '/tipos-contratos',
        menuKey: '/tipos-contratos',
        component: TypeContractPage,
        text: 'Tipos de contrato',
        icon: {
            family: 'FontAwesome',
            name: 'BusinessTime',
        },
        permissions: [
            {
                can: 'find',
                an: 'TipoContrato',
            },
        ],
    },
    {
        path: '/tipos-contratos/novo',
        menuKey: '/tipos-contratos',
        component: TypeContractCreateUpdatePage,
        permissions: [
            {
                can: 'create',
                an: 'TipoContrato',
            },
        ],
    },
    {
        path: '/tipos-contratos/:id',
        menuKey: '/tipos-contratos',
        component: TypeContractCreateUpdatePage,
        permissions: [
            {
                can: 'update',
                an: 'TipoContrato',
            },
        ],
    },
];
const TYPE_ABSENCES = [
    {
        exact: true,
        path: '/tipos-faltas',
        menuKey: '/tipos-faltas',
        component: TypeAbsences,
        text: 'Tipos de falta',
        icon: {
            family: 'FontAwesome',
            name: 'UserSlash',
        },
        permissions: [
            {
                can: 'find',
                an: 'ColaboradorFalta',
            },
        ],
    },
    {
        path: '/tipos-faltas/novo',
        menuKey: '/tipos-faltas',
        component: TypeAbsencesCreateUpdatePage,
        permissions: [
            {
                can: 'create',
                an: 'ColaboradorFalta',
            },
        ],
    },
    {
        path: '/tipos-faltas/:id',
        menuKey: '/tipos-faltas',
        component: TypeAbsencesCreateUpdatePage,
        permissions: [
            {
                can: 'update',
                an: 'ColaboradorFalta',
            },
        ],
    },
];

const DEPARTMENT = [
    {
        exact: true,
        path: '/departamentos',
        menuKey: '/departamentos',
        component: DepartmentPage,
        text: 'Departamentos',
        icon: {
            family: 'FontAwesome',
            name: 'Server',
        },
        permissions: [
            {
                can: 'find',
                an: 'Departamento',
            },
        ],
    },
    {
        path: '/departamentos/novo',
        menuKey: '/departamentos',
        component: DepartmentCreateUpdatePage,
        permissions: [
            {
                can: 'create',
                an: 'Departamento',
            },
        ],
    },
    {
        path: '/departamentos/:id',
        menuKey: '/departamentos',
        component: DepartmentCreateUpdatePage,
        permissions: [
            {
                can: 'update',
                an: 'Departamento',
            },
        ],
    },
];

const SCHOOLING = [
    {
        exact: true,
        path: '/escolaridades',
        menuKey: '/escolaridades',
        component: SchoolingPage,
        text: 'Escolaridades',
        icon: {
            family: 'FontAwesome',
            name: 'Book',
        },
        permissions: [
            {
                can: 'find',
                an: 'Escolaridade',
            },
        ],
    },
    {
        path: '/escolaridades/novo',
        menuKey: '/escolaridades',
        component: SchoolingCreateUpdatePage,
        permissions: [
            {
                can: 'create',
                an: 'Escolaridade',
            },
        ],
    },
    {
        path: '/escolaridades/:id',
        menuKey: '/escolaridades',
        component: SchoolingCreateUpdatePage,
        permissions: [
            {
                can: 'update',
                an: 'Escolaridade',
            },
        ],
    },
];

const KINSHIP = [
    {
        exact: true,
        path: '/parentescos',
        menuKey: '/parentescos',
        component: KinshipPage,
        text: 'Parentescos',
        icon: {
            family: 'FontAwesome',
            name: 'Users',
        },
        permissions: [
            {
                can: 'find',
                an: 'Parentesco',
            },
        ],
    },
    {
        path: '/parentescos/novo',
        menuKey: '/parentescos',
        component: KinshipCreateUpdatePage,
        permissions: [
            {
                can: 'create',
                an: 'Parentesco',
            },
        ],
    },
    {
        path: '/parentescos/:id',
        menuKey: '/parentescos',
        component: KinshipCreateUpdatePage,
        permissions: [
            {
                can: 'update',
                an: 'Parentesco',
            },
        ],
    },
];

const CIVIL_STATUS = [
    {
        exact: true,
        path: '/estado-civil',
        menuKey: '/estado-civil',
        component: CivilStatusPage,
        text: 'Estado Civil',
        icon: {
            family: 'FontAwesome',
            name: 'RegHeart',
        },
        permissions: [
            {
                can: 'find',
                an: 'EstadoCivil',
            },
        ],
    },
    {
        path: '/estado-civil/novo',
        menuKey: '/estado-civil',
        component: CivilStatusCreateupdatePage,
        permissions: [
            {
                can: 'create',
                an: 'EstadoCivil',
            },
        ],
    },
    {
        path: '/estado-civil/:id',
        menuKey: '/estado-civil',
        component: CivilStatusCreateupdatePage,
        permissions: [
            {
                can: 'update',
                an: 'EstadoCivil',
            },
        ],
    },
];

const ACCOUNT_TYPE = [
    {
        exact: true,
        path: '/tipos-contas',
        menuKey: '/tipos-contas',
        component: AccountTypePage,
        text: 'Tipos de contas',
        icon: {
            family: 'FontAwesome',
            name: 'ProjectDiagram',
        },
        permissions: [
            {
                can: 'find',
                an: 'TipoConta',
            },
        ],
    },
    {
        path: '/tipos-contas/novo',
        menuKey: '/tipos-contas',
        component: AccountTypeCreateUpdatePage,
        permissions: [
            {
                can: 'create',
                an: 'TipoConta',
            },
        ],
    },
    {
        path: '/tipos-contas/:id',
        menuKey: '/tipos-contas',
        component: AccountTypeCreateUpdatePage,
        permissions: [
            {
                can: 'update',
                an: 'TipoConta',
            },
        ],
    },
];

const LAWYER = [
    {
        exact: true,
        path: '/advogados',
        menuKey: '/advogados',
        component: LawyerPage,
        text: 'Advogados',
        icon: {
            family: 'FontAwesome',
            name: 'BalanceScale',
        },
        permissions: [
            {
                can: 'find',
                an: 'Advogado',
            },
        ],
    },
    {
        path: '/advogados/novo',
        menuKey: '/advogados',
        component: LawyerCreateUpdatePage,
        permissions: [
            {
                can: 'create',
                an: 'Advogado',
            },
        ],
    },
    {
        path: '/advogados/:id',
        menuKey: '/advogados',
        component: LawyerCreateUpdatePage,
        permissions: [
            {
                can: 'update',
                an: 'Advogado',
            },
        ],
    },
];

const CRITERION = [
    {
        exact: true,
        path: '/criterios',
        menuKey: '/criterios',
        component: CriterionPage,
        text: 'Critérios',
        icon: {
            family: 'FontAwesome',
            name: 'PenAlt',
        },
        permissions: [
            {
                can: 'find',
                an: 'Criterio',
            },
        ],
    },
    {
        path: '/criterios/novo',
        menuKey: '/criterios',
        component: CriterionCreateUpdatePage,
        permissions: [
            {
                can: 'create',
                an: 'Criterio',
            },
        ],
    },
    {
        path: '/criterios/:id',
        menuKey: '/criterios',
        component: CriterionCreateUpdatePage,
        permissions: [
            {
                can: 'update',
                an: 'Criterio',
            },
        ],
    },
];

const CLAIMANTS_TYPE = [
    {
        exact: true,
        path: '/tipo-reclamantes',
        menuKey: '/tipo-reclamantes',
        component: ClaimantsTypePage,
        text: 'Tipos de Reclamantes',
        icon: {
            family: 'FontAwesome',
            name: 'RegThumbsDown',
        },
        permissions: [
            {
                can: 'find',
                an: 'ProcessoJudicialTipoReclamante',
            },
        ],
    },
    {
        path: '/tipo-reclamantes/novo',
        menuKey: '/tipo-reclamantes',
        component: ClaimantsTypeCreateUpdatePage,
        permissions: [
            {
                can: 'create',
                an: 'ProcessoJudicialTipoReclamante',
            },
        ],
    },
    {
        path: '/tipo-reclamantes/:id',
        menuKey: '/tipo-reclamantes',
        component: ClaimantsTypeCreateUpdatePage,
        permissions: [
            {
                can: 'update',
                an: 'ProcessoJudicialTipoReclamante',
            },
        ],
    },

];

const COURSE = [
    {
        exact: true,
        path: '/cursos',
        menuKey: '/cursos',
        component: CoursesPage,
        text: 'Cursos',
        icon: {
            family: 'FontAwesome',
            name: 'GraduationCap',
        },
        permissions: [
            {
                can: 'find',
                an: 'Curso',
            },
        ],
    },
    {
        path: '/cursos/novo',
        menuKey: '/cursos',
        component: CoursesCreateUpdatePage,
        permissions: [
            {
                can: 'create',
                an: 'Curso',
            },
        ],
    },
    {
        path: '/cursos/:id',
        menuKey: '/cursos',
        component: CoursesCreateUpdatePage,
        permissions: [
            {
                can: 'update',
                an: 'Curso',
            },
        ],
    },
];

const TYPE_DOCUMENT = [
    {
        exact: true,
        path: '/tipos-documentacoes',
        menuKey: '/tipos-documentacoes',
        component: DocumentsTypesPage,
        text: 'Tipos de documento',
        icon: {
            family: 'FontAwesome',
            name: 'AddressCard',
        },
        permissions: [
            {
                can: 'find',
                an: 'TipoDocumentacao',
            },
        ],
    },
    {
        path: '/tipos-documentacoes/novo',
        menuKey: '/tipos-documentacoes',
        component: DocumentsTypesCreateUpdatePage,
        permissions: [
            {
                can: 'create',
                an: 'TipoDocumentacao',
            },
        ],
    },
    {
        path: '/tipos-documentacoes/:id',
        menuKey: '/tipos-documentacoes',
        component: DocumentsTypesCreateUpdatePage,
        permissions: [
            {
                can: 'update',
                an: 'TipoDocumentacao',
            },
        ],
    },
];

const BANK_MENU = [
    {
        group: 'Bancário',
        icon: {
            family: 'FontAwesome',
            name: 'Landmark',
        },
        routes: [
            ...BANKS,
            ...ACCOUNT_TYPE,
        ],
    },
];

const EDUCATION_MENU = [
    {
        group: 'Educação',
        icon: {
            family: 'FontAwesome',
            name: 'Stream',
        },
        routes: [
            ...COURSE,
            ...SCHOOLING,
            ...ACADEMIC_DEGREES,
        ],
    },
];

const DOCTORS = [
    {
        exact: true,
        path: '/medicos',
        menuKey: '/medicos',
        component: DoctorsPage,
        text: 'Médicos',
        icon: {
            family: 'MaterialIcons',
            name: 'LocalHospital',
        },
        permissions: [
            {
                can: 'find',
                an: 'Medico',
            },
        ],
    },
    {
        path: '/medicos/novo',
        menuKey: '/medicos',
        component: DoctorsCreateUpdatePage,
        permissions: [
            {
                can: 'create',
                an: 'Medico',
            },
        ],
    },
    {
        path: '/medicos/:medicoId',
        menuKey: '/medicos',
        component: DoctorsCreateUpdatePage,
        permissions: [
            {
                can: 'update',
                an: 'Medico',
            },
        ],
    },
];

const HEALTH_MENU = [
    {
        group: 'Saúde',
        icon: {
            family: 'FontAwesome',
            name: 'Heartbeat',
        },
        routes: [
            ...DOCTORS,
        ],
    },
];

const ORGANIZATIONAL_MENU = [
    {
        group: 'Organizacional',
        icon: {
            family: 'FontAwesome',
            name: 'LayerGroup',
        },
        routes: [
            ...POSITIONS,
            ...CRITERION,
            ...DEPARTMENT,
            ...COMPANIES,
            ...GREETINGS,
            ...UNIONS,
            ...TYPE_CONTRACT,
            ...TYPE_DOCUMENT,
            ...TYPE_ABSENCES,
        ],
    },
];

const FAMILIAR_MENU = [
    {
        group: 'Família',
        icon: {
            family: 'FontAwesome',
            name: 'Users',
        },
        routes: [
            ...CIVIL_STATUS,
            ...KINSHIP,
        ],
    },
];

const BENEFITS_MENU = [
    {
        group: 'Benefícios',
        icon: {
            family: 'FontAwesome',
            name: 'CreditCard',
        },
        routes: [
            ...BENEFITS,
            ...UNITS,

        ],
    },
];

const EMPLOYEES_MENU = [
    {
        group: 'Gerenciamento',
        icon: {
            family: 'FontAwesome',
            name: 'UserFriends',
        },
        permissions: [
            {
                can: 'find',
                an: 'ColaboradorDadosGerais',
            },
        ],
        routes: [
            {
                exact: true,
                path: '/colaboradores',
                menuKey: '/colaboradores',
                component: EmployeesPage,
                text: 'Colaboradores',
                icon: {
                    family: 'FontAwesome',
                    name: 'UserPlus',
                },
                permissions: [
                    {
                        can: 'find',
                        an: 'ColaboradorDadosGerais',
                    },
                ],
            },
            {
                path: '/colaboradores/novo',
                menuKey: '/colaboradores',
                component: EmployeesCreateUpdatePage,
                permissions: [
                    {
                        can: 'create',
                        an: 'ColaboradorDadosGerais',
                    },
                ],
            },
            {
                path: '/colaboradores/:employeeId/visualizar',
                menuKey: '/colaboradores',
                component: EmployeeManagementPage,
                permissions: [
                    {
                        can: 'find',
                        an: 'ColaboradorDadosGerais',
                    },
                ],
            },
            ...BANK_MENU,
            ...BENEFITS_MENU,
            ...EDUCATION_MENU,
            ...FAMILIAR_MENU,
            ...HEALTH_MENU,
            ...ORGANIZATIONAL_MENU,
        ],
    },
];

const JUSTICE_PROCESS = [
    {
        group: 'Processos Judiciais',
        icon: {
            family: 'FontAwesome',
            name: 'Scroll',
        },
        permissions: [
            {
                can: 'find',
                an: 'ProcessoDadosGerais',
            },
        ],
        routes: [
            {
                exact: true,
                path: '/processos-judiciais',
                menuKey: '/processos-judiciais',
                component: JusticeProcessPage,
                text: 'Gerenciamento de Processos',
                icon: {
                    family: 'FontAwesome',
                    name: 'UserCog',
                },
                permissions: [
                    {
                        can: 'find',
                        an: 'ProcessoDadosGerais',
                    },
                ],
            },
            {
                path: '/processos-judiciais/novo',
                menuKey: '/processos-judiciais',
                component: JusticeCreatePage,
                permissions: [
                    {
                        can: 'create',
                        an: 'ProcessoDadosGerais',
                    },
                ],
            },
            {
                path: '/processos-judiciais/:processId',
                menuKey: '/processos-judiciais',
                component: JusticeProcessManagementPage,
                permissions: [
                    {
                        can: 'update',
                        an: 'ProcessoDadosGerais',
                    },
                ],
            },
            {
                group: 'Dados gerais',
                icon: {
                    family: 'FontAwesome',
                    name: 'Stream',
                },
                routes: [
                    ...LAWYER,
                    ...CLAIMANTS_TYPE,
                ],
            },
        ],
    },
];

const USERS_MENU = [
    {
        group: 'Cadastro de Usuários',
        icon: {
            family: 'FontAwesome',
            name: 'UserPlus',
        },
        permissions: [
            {
                can: 'find',
                an: 'Usuario',
            },
        ],
        routes: [
            {
                exact: true,
                path: '/usuarios',
                menuKey: '/usuarios',
                component: UsersPage,
                text: 'Usuários',
                icon: {
                    family: 'FontAwesome',
                    name: 'Users',
                },
                permissions: [
                    {
                        can: 'find',
                        an: 'Usuario',
                    },
                ],
            },
            {
                path: '/usuarios/novo',
                menuKey: '/usuarios',
                component: UsersCreateUpdatePage,
                permissions: [
                    {
                        can: 'create',
                        an: 'Usuario',
                    },
                ],
            },
            {
                path: '/usuarios/:userId',
                menuKey: '/usuarios',
                component: UsersCreateUpdatePage,
                permissions: [
                    {
                        can: 'update',
                        an: 'Usuario',
                    },
                ],
            },
        ],
    },
];

const PROFILE = [
    {
        path: '/perfil',
        component: ProfilePage,
        exact: true,
    },
];

const SIGNATURES = [
    {
        path: '/assinatura',
        menuKey: '/assinatura',
        component: SignaturePage,
        text: 'Minha assinatura',
        icon: {
            family: 'FontAwesome',
            name: 'MoneyCheckAlt',
        },
        exact: true,
    },
];

const ROUTES = [
    {
        path: '/',
        menuKey: '/',
        component: HomePage,
        text: 'Home',
        icon: {
            name: 'dashboard',
        },
        exact: true,
    },
    ...PROFILE,
    ...EMPLOYEES_MENU,
    ...JUSTICE_PROCESS,
    ...USERS_MENU,
    ...SIGNATURES,
];

if (process.env.REACT_APP_ENV !== 'production') {
    ROUTES.push({
        path: '/changelog',
        menuKey: '/changelog',
        component: ChangelogPage,
        text: 'Changelog',
        icon: { name: 'info' },
        exact: true,
    });
}

export default ROUTES;

export const allRoutes = getRoutesArray({
    group: 'root',
    routes: ROUTES,
});
